import { jsx as _jsx } from "react/jsx-runtime";
export function Spinner({ size = 20, label = 'Loading', className }) {
    return (_jsx("span", { className: className, role: "status", "aria-label": label, "data-spinner": true, style: {
            display: 'inline-block',
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: '9999px',
            border: `2px solid var(--border)`,
            borderTopColor: 'var(--accent)',
            animation: 'spinner-rotate 800ms linear infinite',
        } }));
}
//# sourceMappingURL=Spinner.js.map